// api/flags.ts — W2.5 client for the server-side feature flag resolver.

import { apiJson } from './client';

export type FlagState = 'on' | 'off';
export type FlagSource = 'student' | 'cohort' | 'school' | 'default';

export interface ResolvedFlagDto {
  key: string;
  state: FlagState;
  source: FlagSource;
}

export const flagsApi = {
  /**
   * Bulk-resolve every registered flag for the current student. Single round
   * trip; the backend reads scope ids (student / cohort / school) from the
   * JWT, so no params needed.
   */
  async list(): Promise<ResolvedFlagDto[]> {
    const res = await apiJson<{ flags: ResolvedFlagDto[] }>('/api/flags');
    return res.flags;
  },
};
